// extracted by mini-css-extract-plugin
module.exports = {"warning":"styles_warning__2wCEj","domainId":"styles_domainId__1WLdj","collapse":"styles_collapse__3jvyp"};